<template>
  <div>
    <div class="content">
      <div class="md-layout">
        <div class="md-layout-item">
          <md-card class="md-card-plain">
            <md-card-header data-background-color="#cccccc">
              <h4 class="title">HDR Files</h4>
              <p class="category">List of all HDR Files</p>

              <v-btn icon style="position: relative; text-align: right">
                <v-icon color="grey lighten-1" @click="printDe(item.id)"
                  >mdi-add</v-icon
                >
              </v-btn>
            </md-card-header>

            <md-card-content>
              <!--
              <v-layout row justify-center class="ma-5">
                <v-btn @click="addfile">Add New Asset</v-btn>
              </v-layout>
              -->
              <v-row justify="center">
                <v-dialog v-model="dialog" persistent max-width="600px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="primary" dark v-bind="attrs" v-on="on">
                      Add New Asset
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="headline">HDR Asset</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12">
                            <v-text-field
                              label="File name*"
                              v-model="hdrFileName"
                              required
                            ></v-text-field>
                          </v-col>

                          <v-file-input
                            cols="12"
                            accept=".hdr"
                            v-model="hdrFile"
                            placeholder="Pick HDR File"
                            label="HDR"
                            required
                          ></v-file-input>
                        </v-row>
                      </v-container>
                      <small>*indicates required field</small>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="dialog = false">
                        Close
                      </v-btn>
                      <v-btn color="blue darken-1" text @click="submitFile">
                        Save
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-row>
              <div>
                <v-flex xs12>
                  <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-flex>

                <v-flex xs12>
                  <v-data-table
                    v-model="selected1"
                    :headers="headers1"
                    :items="hdrFileItems"
                    :search="search"
                    :single-select="singleSelect"
                    item-key="name"
                    class="elevation-1"
                    @click:row="handleClick"
                  >
                    <template v-slot:item.actions="{ item }">
                      <!-- <v-icon @click="editItem(item)">mdi-pencil</v-icon> -->
                      <v-icon @click="deleteItem(item)">mdi-delete</v-icon>
                    </template>
                  </v-data-table>
                </v-flex>
              </div>
            </md-card-content>
          </md-card>
        </div>
      </div>
      <v-overlay :value="overlayP">
        <v-progress-circular v-bind="spinnerProps"
          ><div>Uploading</div></v-progress-circular
        >
      </v-overlay>
    </div>
  </div>
</template>

<script>
//import "../assets/scss/material-dashboard.scss";

import axios from "axios";

axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
axios.defaults.xsrfCookieName = "csrftoken";

export default {
  data: () => ({
    serverItems: [],

    itemClick: false,
    actionClick: false,

    singleSelect: false,
    selected1: [],
    search: "",
    dialog: false,
    headers1: [
      {
        text: "File Name",
        align: "start",
        sortable: false,
        value: "filename",
      },
      {
        text: "Uploaded File Name",
        align: "start",
        sortable: false,
        value: "uploadfilename",
      },
      { text: "Uploaded", value: "created_at" },

      { text: "Actions", value: "actions", sortable: false },
    ],

    show_start_date: false,
    start_date: null,

    show_end_date: false,
    end_date: null,

    filters: {
      search: "",
      added_by: "",
      start_date: null,
      end_date: null,
    },
    authors: ["Admin", "Foo"],
    pagination: {
      sortBy: "name",
    },

    hdrFileItems: [],
    hdrFile: "",
    hdrFileName: "",
    overlayP: false,
  }),

  mounted() {
    //HDR files
    axios
      .get("/hdrfile/") //for local "/hdrfile/"
      .then((response) => {
        var i;
        var len;

        this.hdrFileItems = response.data;
        console.log(response.data);

        for (i = 0, len = response.data.length; i < len; i++) {
          this.hdrFileItems[i].filehdr = "" + response.data[i].file_hdr;
          this.hdrFileItems[i].filename = "" + response.data[i].file_name;
          this.hdrFileItems[i].uploadfilename =
            "" + response.data[i].uploaded_file_name;
          this.hdrFileItems[i].filetype = "" + response.data[i].file_type;
          this.hdrFileItems[i].filecreated = response.data[i].created_at;
          this.hdrFileItems[i].id = response.data[i].id;
        }

        console.log(this.hdrFileItems);
      })
      .catch((error) => {
        console.log(error);
      });

    //hdr Files
  },
  methods: {
    submitFile() {
      this.dialog = false;
      console.log(this.hdrFile.name);
      let formData = new FormData();
      formData.append("file_hdr", this.hdrFile);
      formData.append("file_name", this.hdrFileName);
      formData.append(
        "uploaded_file_name",
        this.hdrFile.name.replace(/\.[^/.]+$/, "")
      );
      formData.append("file_type", "hdr");

      axios
        .post("/hdrfile/", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          axios
            .get("/hdrfile/") //for local "/hdrfile/"
            .then((response) => {
              var i;
              var len;

              this.hdrFileItems = response.data;
              console.log(response.data);

              for (i = 0, len = response.data.length; i < len; i++) {
                this.hdrFileItems[i].filehdr = "" + response.data[i].file_hdr;
                this.hdrFileItems[i].filename = "" + response.data[i].file_name;
                this.hdrFileItems[i].uploadfilename =
                  "" + response.data[i].uploaded_file_name;
                this.hdrFileItems[i].filetype = "" + response.data[i].file_type;
                this.hdrFileItems[i].filecreated = response.data[i].created_at;
                this.hdrFileItems[i].id = response.data[i].id;
              }

              console.log(this.hdrFileItems);
            })
            .catch((error) => {
              console.log(error);
            });
          console.log(response);
          console.log("SUCCESS!!");
          (this.hdrFile = ""), (this.hdrFileName = ""), (this.overlayP = false);
        })

        .catch(function () {
          console.log("FAILURE!!");
          (this.hdrFile = ""), (this.hdrFileName = ""), (this.overlayP = false);
        });

      this.overlayP = true;
    },
    handleClick(item) {
      if (this.actionClick === true) {
        this.actionClick = false;
        return;
      }

      var item1 = {
        filename: "",
        filepng: "",
        fileglb: "",
        filetype: "",
        tags: "",
        state: "",
        created_at: "",
        description: "",
        id: "",
      };

      item1.filename = item.filename;
      item1.filepng = item.filepng;
      item1.fileglb = item.fileglb;
      item1.fileglb = item.fileglb;
      item1.tags = item.tags;
      item1.state = item.state;
      item1.created_at = item.created_at;
      item1.description = item.description;
      item1.id = item.id;

      console.log(item.filename);
      this.$store.commit("setFileDetail", item1);
      //this.$router.push({ path: "/asset/detail", params: { file: item1 } });
      //this.$router.push({ path: "/asset/detail" });
    },

    deleteItem(item) {
      this.actionClick = true;
      console.log(item.id);

      confirm("Are you sure you want to delete this item?") &&
        this.deleteServerItem(item.id);
    },

    deleteServerItem(y) {
      console.log(y);
      console.log("Delete");

      axios
        .delete("/hdrfile/" + y + "/") //for local "/hdrfile/"
        .then((response) => {
          console.log(response);

          axios
            .get("/hdrfile/") //for local "/hdrfile/"
            .then((response) => {
              var i;
              var len;

              this.hdrFileItems = response.data;
              console.log(response.data);

              for (i = 0, len = response.data.length; i < len; i++) {
                this.hdrFileItems[i].filehdr = "" + response.data[i].file_hdr;
                this.hdrFileItems[i].filename = "" + response.data[i].file_name;
                this.hdrFileItems[i].uploadfilename =
                  "" + response.data[i].uploaded_file_name;
                this.hdrFileItems[i].filetype = "" + response.data[i].file_type;
                this.hdrFileItems[i].filecreated = response.data[i].created_at;
                this.hdrFileItems[i].id = response.data[i].id;
              }

              console.log(this.hdrFileItems);
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
          //this.errored = true;
        });
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
      } else {
        this.desserts.push(this.editedItem);
      }
      this.close();
    },

    customFilter(items, filters, filter, headers) {
      // Init the filter class.
      const cf = new this.$MultiFilters(items, filters, filter, headers);
      // Use regular function(),
      // arrow functions does not allow context binding.
      // Register the global standard filter.
      cf.registerFilter("search", function (searchWord, items) {
        if (searchWord.trim() === "") return items;
        return items.filter((item) => {
          return item.name.toLowerCase().includes(searchWord.toLowerCase());
        }, searchWord);
      });
      // Use regular function(),
      // arrow functions does not allow context binding.
      // Register "added_by" filter.
      cf.registerFilter("added_by", function (added_by, items) {
        // If the filter has not been applied yet
        // just return all available items.
        if (added_by.trim() === "") return items;
        // Compare each item added_by and just return the matching ones.
        return items.filter((item) => {
          return item.added_by.toLowerCase() === added_by.toLowerCase();
        }, added_by);
      });
      // Use regular function(),
      // arrow functions does not allow context binding.
      // Register "start_date" filter.
      cf.registerFilter("start_date", function (start_date, items) {
        // If the filter has not been applied yet
        // just return all available items.
        if (start_date === null) return items;
        // Compare each item start_date and just return the matching ones.
        return items.filter((item) => {
          return item.birth_date >= start_date;
        }, start_date);
      });
      // Use regular function(),
      // arrow functions does not allow context binding.
      // Register "end_date" filter.
      cf.registerFilter("end_date", function (end_date, items) {
        // If the filter has not been applied yet
        // just return all available items.
        if (end_date === null) return items;
        // Compare each item end_date and just return the matching ones.
        return items.filter((item) => {
          return item.birth_date <= end_date;
        }, end_date);
      });
      // Its time to run all created filters.
      // Will be executed in the order thay were defined.
      return cf.runFilters();
    },
    /**
     * Toggle selected items with the master checkbox.
     */
    toggleAll() {
      if (this.selected.length) {
        this.selected = [];
      } else {
        this.selected = this.rows.slice();
      }
    },
    /**
     * Column shorting.
     *
     * @param column
     */
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    /**
     * Handler when user input something at the "Filter" text field.
     */
    filterSearch(val) {
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        search: val,
      });
    },
    /**
     * Handler when user  select some author at the "Author" select.
     */
    filterAuthor(val) {
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        added_by: val,
      });
      console.log(this.filters);
    },
    /**
     * Handler when select a date on "From" date picker.
     */
    filterStartDate(val) {
      // Close the date picker.
      this.$refs.show_start_date.save(val);
      //Convert the value to a timestamp before saving it.
      const timestamp = new Date(val + "T00:00:00Z").getTime();
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        start_date: timestamp,
      });
    },
    /**
     * Handler when select a date on "To" date picker.
     */
    filterEndDate(val) {
      // Close the date picker.
      this.$refs.show_end_date.save(val);
      //Convert the value to a timestamp before saving it.
      const timestamp = new Date(val + "T00:00:00Z").getTime();
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        end_date: timestamp,
      });
    },
  },
  filters: {
    /**
     * Format a timestamp into a d/m/yyy (because spanish format).
     *
     * @param value
     * @returns {string}
     */
    formatDate: function (value) {
      if (!value) return "";
      return new Date(value).toLocaleDateString("es-ES");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/material-dashboard.scss";
</style>
